import { Component, OnInit, ViewChild } from '@angular/core';
import { DataShareService } from '../../shared/services/data.service';
import { CommonService } from '../../shared/services/common.service';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { MessageService } from '../../shared/services/message.service';
import { Constants } from '../common/constants';
import { CommonMessage } from '../common/common-messages';
import { MyTicketsComponent } from './my-tickets.component';
import { MyTeamTicketsComponent } from './my-team-tickets.component';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { Permission } from '../../common/enums/permission.enum';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { TicketTab } from '../enums/ticket-tab.enum';
import { TabsetComponent } from 'ngx-bootstrap/tabs/tabset.component';
import { TabConstants } from '../constants/tab.constants';
import { CustomerService } from '../services/customer.service';
import { NotificationType } from '../enums/notification-types.enum';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { FdTicketsComponent } from './fd-tickets.component';
import { Department } from '../enums/department-type.enum';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'work-tickets',
    templateUrl: '../templates/template1/views/work-tickets.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less'
    ]
})
export class WorkTicketsComponent implements OnInit {
  @ViewChild(MyTicketsComponent) myTicketsComponent: MyTicketsComponent;
  @ViewChild(MyTeamTicketsComponent) myTeamTicketsComponent: MyTeamTicketsComponent;
  @ViewChild('workTicketTabs') workTicketTabs: TabsetComponent;
  enableFDTicketsTab: boolean = environment.enableFDTicketsTab;
  active = true;
  isRecentlyViewed = false;
  fdTabsActive = false

    id: any;
    tabTitle: string;
    componentName: any;
    ticketId: any;
    isView: boolean;
    ticketCategory: number;
    tabModel: ViewTabModel;
    tabs: any[] = new Array<ViewTabModel>();
    existedValues: ViewTabModel[] = new Array<ViewTabModel>();
    deleteModal: DeleteModal;
    justifyingTabs = false;
    ticketTabs: TicketTabInfo[] = new Array<TicketTabInfo>();
    activetab: number;
    hasBonusReissuePermission: boolean;
    ticketTab = TicketTab;
    operatingCountries: any;
    statusTypes: any;
    sourceTypes: any;
    ticketPriorities: any;
    ticketLimitMessage: string;
    hasFDTabPermission: boolean;
    departments: any[];
    allDepartment:any[]=[];
    userInfo: any;

    constructor(private _dataShareService: DataShareService,
        private _commonService: CommonService, private messageService: MessageService,
        private _customerservice: CustomerService,
        private _localStorageService: LocalStorageService) {
    }

    ngOnInit(): void {
        this.tabModel = new ViewTabModel();
        this.userInfo = this._localStorageService.get("UserInfo");
        this.checkUserHasFDDepartmentAccess();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.subscribeTicketTabClose();
        this.getPermissionsList();
        this.active = false;
        this.activetab = 1;
        this.getOperatingCountries();
        this.getTicketStatus();
        this.getSourceTypes();
        this.getTicketPriorities();
    }

    /**
     * @description This method used to get all permissions
     * getPermissionsList()
     * @memberof WorkTicketsComponent
    */
    getPermissionsList(): void {
        this.hasBonusReissuePermission = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.BONUS_REISSUE_TICKETS_CREATE + ']'), AccessLevel.Customer_Service
        );
    }
 
  selectTab(tab: any): void {
    this.activetab = tab;
    if (tab === TicketTab.MY_TICKET) {
      this.myTicketsComponent.onSearch(true);
    } else if (tab === TicketTab.MY_TEAM_TICKET) {
      this.myTeamTicketsComponent.onSearch(true);
    }
     else if (tab === TicketTab.FORM_TICKET) {
      this.isRecentlyViewed = true;
    }
    else if (tab === TicketTab.FD_TICKET) {
        this.fdTabsActive = true 
      }
  }

    /**  
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof WorkTicketsComponent
     */
    changeTab(tab: any): void {
        this.activetab = tab;
    }

    /**
     * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
     */
    subscribeClosedTabs(): void {
        this.messageService.getCloseTabsEvent().subscribe((data: any) => {
            if (data) {
            }
        });
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof WorkTicketsComponent
     */
    addNewTab(): void {
        const newTabIndex = this.tabs.length + 1;
        this.tabModel = new ViewTabModel();
        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.ticketId = this.ticketId;
        this.tabModel.isView = this.isView;
        this.tabModel.tabIndex = newTabIndex + 2;
        this.tabModel.ticketCategory = this.ticketCategory;
        this.tabModel.componentName = this.componentName;
        this.activetab = newTabIndex + 2;
        this.existedValues = new Array<ViewTabModel>();
        const index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            // this.tabs.splice(0, 1);
            this.displayAlertBoxOnReachingMaxTabs();
        } else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            } else {
                const selectedId = this.id;
                this.tabs.forEach(function (x: ViewTabModel) {
                    if (x.id !== selectedId) {
                        x.active = false;
                    } else {
                        x.active = true;
                    }
                });
            }
        }
    }

    /**
     * removes tab at specific index
     * @param tab
     */
    removeTabHandler(tab: any): void {
        if (this.tabs) {

            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
            this.activetab = tab.ticketCategory;
        }
    }

    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    displayAlertBoxOnReachingMaxTabs() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof WorkTicketsComponent
     */
    subscribeTabContent() {
        this.messageService.getCustomerServiceUserTabContent().subscribe((data: TicketTabInfo) => {
            this.addToTicketTabs(data);
        });
    }

    /**
     * @description
     * @date 2020-03-05
     * @param {TicketTabInfo} data
     * @memberof WorkTicketsComponent
     */
    addToTicketTabs(data: TicketTabInfo) {
        if (data) {
            if (this.ticketTabs.length === Constants.MaximumTabsLength) {
                // need to display information -- as you reached maxiumum number of tabs.
                this.ticketLimitMessage = 'Reached maximum (5) tabs limit! Close existing tab(s).';
                this._commonService.createNotification('', this.ticketLimitMessage, NotificationType.ERROR);
                return;
            }
            this.activetab = 0;
            this.ticketTabs.forEach((tab: TicketTabInfo) => tab.active = false);
            const ticketTab = this.ticketTabs.find((tab: TicketTabInfo) => tab.ticketID === data.ticketID);
            if (data.editTicket) {
                this.removeTicketTab(ticketTab);
            }
            if (data.viewTicket && ticketTab && ticketTab.viewTicket) {
                this.ticketTabs.forEach((tab: TicketTabInfo) => {
                    if (tab.ticketID === data.ticketID && tab.viewTicket === true) { tab.active = true; } });
            } else {
                data.active = true;
                data.disabled = false;
                data.removable = true;
                this.ticketTabs.push(data);
            }
            this.alignTabs();
            }
        }

    /**
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof WorkTicketsComponent
     */
    removeTicketTab(tab: any) {
        if (this.ticketTabs) {
            this.ticketTabs.splice(this.ticketTabs.indexOf(tab), 1);
            this.alignTabs();
            if (tab.isTeamTicket && !tab.isFormTicket) {
                const tabIndex = this.workTicketTabs.tabs.findIndex(item => item.id === TabConstants.MY_TEAM_TICKETS);
                this.workTicketTabs.tabs[tabIndex].active = true;
                this.activetab = this.ticketTab.MY_TEAM_TICKET;
            } else if(tab.isFormTicket) {
              const tabIndex = this.workTicketTabs.tabs.findIndex(item => item.id === TabConstants.FORM_TICKETS);
              this.workTicketTabs.tabs[tabIndex].active = true;
              this.activetab = this.ticketTab.FORM_TICKET;
            } 
            else if(tab.isFdTicket) {
                const tabIndex = this.workTicketTabs.tabs.findIndex(item => item.id === TabConstants.FD_TICKETS);
                this.workTicketTabs.tabs[tabIndex].active = true;
                this.activetab = this.ticketTab.FD_TICKET;
              }
            else {
                const tabIndex = this.workTicketTabs.tabs.findIndex(item => item.id === TabConstants.MY_TICKETS);
                this.workTicketTabs.tabs[tabIndex].active = true;
                this.activetab = this.ticketTab.MY_TICKET;
            }
        }
    }
    /**
    * @description To align tab content top
    * @date 2020-01-29
    * @memberof WorkTicketsComponent
    */
    alignTabs(): void {
        setTimeout(() => {
            const element: any = document.querySelector('.cs-primary-tabs.nav > .nav-tabs');
            const tabContentElement: any = document.querySelector('.cs-primary-tabs.nav > .tab-content');
            if (element && tabContentElement) {
                const tabsHeight = element.offsetHeight;
                tabContentElement.style.marginTop = (tabsHeight + 5) + 'px';
            }
        }, 100);
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof WorkTicketsComponent
     */
    subscribeTicketTabClose() {
        this.messageService.getClosingTabInfo().subscribe((data: any) => {
            if (data) {
                this.ticketTabs.forEach((tickeTab: TicketTabInfo) => tickeTab.active = false);
                if (this.ticketTabs.length > 0) {
                    const tab = this.ticketTabs[data.tabIndex];
                    this.removeTicketTab(tab);
                }
                this.goToTicketView(data.ticketID, data.ticketNumber, data.isTeamTicket, data.isFormTicket,data.isFdTicket);
            }
        });
    }

    /**
     * @description
     * @date 2020-03-05
     * @param {number} ticketId
     * @param {string} ticketNumber
     * @param {boolean} isTeamTicket
     * @param {boolean} isFormTicket
     * @param {boolean} isFdTicket
     * @memberof WorkTicketsComponent
     */
    goToTicketView(ticketId: number, ticketNumber: string, isTeamTicket: boolean, isFormTicket?: boolean,isFdTicket?:boolean) {
        const ticketTab = new TicketTabInfo();
        ticketTab.isNewTicket = false;
        ticketTab.ticketID = ticketId;
        ticketTab.title = 'View Ticket - ' + ticketNumber;
        ticketTab.isTeamTicket = isTeamTicket ? isTeamTicket : false;
        ticketTab.isFormTicket = isFormTicket ? isFormTicket : false;
        ticketTab.isFdTicket = isFdTicket ? isFdTicket : false;
        ticketTab.viewTicket = true;
        this.addToTicketTabs(ticketTab);
    }

    getOperatingCountries() {
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.operatingCountries = response;
            }
        });
    }
    getTicketStatus() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.statusTypes = response;
                this.statusTypes.sort(function (item1, item2) {
                    const status1 = item1.value.toLowerCase(), status2 = item2.value.toLowerCase();
                    if (status1 < status2) { //sort string ascending
                        return -1;
                    }
                    if (status1 > status2) {
                        return 1;
                    }
                    return 0;
                });
            }
        });
    }

    getSourceTypes() {
        this._customerservice.getSourceTypes().subscribe((response) => {
            if (response) {
                this.sourceTypes = response;
                this.sourceTypes.sort(function (item1, item2) {
                    const source1 = item1.value.toLowerCase(), source2 = item2.value.toLowerCase();
                    if (source1 < source2) { //sort string ascending
                        return -1;
                    }
                    if (source1 > source2) {
                        return 1;
                    }
                    return 0;
                });
            }
        });
    }

    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {
                this.ticketPriorities = response;
                this.ticketPriorities.sort(function (item1, item2) {
                    const priority1 = item1.value.toLowerCase(), priority2 = item2.value.toLowerCase();
                    if (priority1 < priority2) { //sort string ascending
                        return -1;
                    }
                    if (priority1 > priority2) {
                        return 1;
                    }
                    return 0;
                });
            }
        });
    }

    checkUserHasFDDepartmentAccess() {
        this._customerservice.getAllDepartmentsByOperatingCountryId(null).subscribe((response) => {
            if (response) {
                this.departments = response;
                this.allDepartment = response;
                const FdDepartments =  this.allDepartment? this.allDepartment.filter(dept => dept.value.toLowerCase() == Department.FD.toLowerCase().trim()) : [];
                let departmentIds = this.userInfo.privileges.departments.map(function (a: any) { return a.id; });
                this.departments = this.departments.filter(function (item) {
                    return departmentIds.indexOf(item.id) != -1 && item.value.toLowerCase() === Department.FD.toLowerCase();
                });
                if (this.userInfo.hasSystemRole && FdDepartments.length>0) {
                    this.hasFDTabPermission = true;
                }
                else if (!this.userInfo.hasSystemRole && this.departments && this.departments.length > 0) {
                    this.hasFDTabPermission = true;
                    this.allDepartment = this.departments;
                }
                else {
                    this.hasFDTabPermission = false;
                    this.allDepartment = [];
                }
            }
            else {
                this.hasFDTabPermission = false;
                this.allDepartment = [];
            }
        },
            error => {
                this.hasFDTabPermission = false;
                this.allDepartment = [];
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/work-tickets.component.ts